import React, { useEffect, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import Skeleton from "react-loading-skeleton";
import ReusableTable from "components/Tables/ReusableTable";
import GradientButton from "components/Buttons/GradientButton";
import ThreeDotMenu from "components/Menus/ThreeDotMenu";
import { Eye, Pencil, Archive, EllipsisVertical } from "lucide-react";

import { useDispatch, useSelector } from "react-redux";
import {
    fetchContactLogsAction,
    createContactLogAction,
    updateContactLogAction,
    
    deleteContactLogAction,
} from "../../../state/actions/contactLogActions";

import AddContactLogDrawer from "./components/AddContactLogDrawer";
import ViewContactLogDrawer from "./components/ViewContactLogDrawer";
import EditContactLogDrawer from "./components/EditContactLogDrawer";
import DeleteContactLogModal from "./components/DeleteContactLogModal";

import { useCustomNotification } from "components/Toasts/OpenNotification";
import { formatDate } from "utils/formatDate";
import StatusBadge, {
    getStatusVariant,
} from "../../../components/Badges/StatusBadge";

const ContactLogManagement = () => {
    const dispatch = useDispatch();
    const notify = useCustomNotification();

    const { logs, loading, pagination } = useSelector(
        (state) => state.contactLogs
    );

    const [selected, setSelected] = useState(null);

    const [isAddOpen, setAddOpen] = useState(false);
    const [isViewOpen, setViewOpen] = useState(false);
    const [isEditOpen, setEditOpen] = useState(false);
    const [isDeleteOpen, setDeleteOpen] = useState(false);

    useEffect(() => {
        dispatch(fetchContactLogsAction());
    }, [dispatch]);

    const getStatusLabel = (status) => {
  switch (status) {
    case "CONTACTED":
      return "Contacted";

    case "NOT_REACHED":
      return "Not Reached";

    case "PENDING":
      return "Pending";

    case "Contacted":
      return "Contacted";

    case "Not Reached":
      return "Not Reached";

    case "Pending":
      return "Pending";

    default:
      return status || "Unknown";
  }
};


    const handleAdd = async (data) => {
        const res = await dispatch(createContactLogAction(data));
        res.success
            ? notify({ type: "success", message: "Log created" })
            : notify({ type: "error", message: res.error });
    };

    const handleUpdate = async (data) => {
        const res = await dispatch(
            updateContactLogAction(selected.contact_log_id, data)
        );

        res.success
            ? notify({ type: "success", message: "Log updated" })
            : notify({ type: "error", message: res.error });
    };

    const handleDelete = async () => {
        const res = await dispatch(
            deleteContactLogAction(selected.contact_log_id)
        );

        res.success
            ? notify({ type: "success", message: "Log deleted" })
            : notify({ type: "error", message: res.error });
    };

    const menuItems = (row) => [
        {
            icon: <Eye size={16} />,
            text: "View",
            onClick: () => {
                setSelected(row.original);
                setViewOpen(true);
            },
        },
        {
            icon: <Pencil size={16} />,
            text: "Edit",
            onClick: () => {
                setSelected(row.original);
                setEditOpen(true);
            },
        },
        {
            icon: <Archive size={16} />,
            text: "Delete",
            onClick: () => {
                setSelected(row.original);
                setDeleteOpen(true);
            },
        },
    ];

    const columns = [
        {
            Header: "User",
            accessor: "user_name",
        },
        { Header: "Reason", accessor: "reason" },
        { Header: "Method", accessor: "contact_method" },
        {
            Header: "Outcome",
            accessor: "outcome",
        },
   {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => (
        <StatusBadge
            label={getStatusLabel(value)}
            variant={getStatusVariant(value)}
        />
    ),
},
        {
            Header: "Follow Up On",
            accessor: "follow_up_date",
        },
        
        {
            Header: "Date",
            accessor: "contacted_at",
            Cell: ({ value }) => formatDate(value),
        },
        {
            Header: "Actions",
            Cell: ({ row }) => (
                <ThreeDotMenu
                    icon={<EllipsisVertical size={20} />}
                    items={menuItems(row)}
                />
            ),
        },
    ];

    return (
        <Box>
            <Flex justify="space-between" mb={4} pt={{ base: "120px", md: "25px" }}>
                <Text fontWeight="bold">
                    {loading ? <Skeleton width={100} /> : `Calls Logged: ${pagination.total}`}
                </Text>

                {/* <GradientButton onClick={() => setAddOpen(true)}>
          Add Contact Log
        </GradientButton> */}
            </Flex>

            <ReusableTable
                columnsData={columns}
                tableData={logs}
                isLoading={loading}
            />

            <AddContactLogDrawer isOpen={isAddOpen} onClose={() => setAddOpen(false)} onAdd={handleAdd} />
            <ViewContactLogDrawer isOpen={isViewOpen} onClose={() => setViewOpen(false)} log={selected} />
            <EditContactLogDrawer isOpen={isEditOpen} onClose={() => setEditOpen(false)} log={selected} onUpdate={handleUpdate} />
            <DeleteContactLogModal isOpen={isDeleteOpen} onClose={() => setDeleteOpen(false)} onConfirm={handleDelete} log={selected} />
        </Box>
    );
};

export default ContactLogManagement;